import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import CustomBlueButton from "../../../../ReUsableComponent/CustomBlueButton";
import { updateBrandReconHeaders } from "../../BrandManagement.service";
import { useSelector } from "react-redux";

const ReconReportBrandEdit = () => {
    const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
    const location = useLocation();
    const history = useHistory();

    const allRows =
        location.state?.allRows ||
        JSON.parse(localStorage.getItem("edit_rows")) ||
        [];

    const brand_id =
        location.state?.brand ||
        localStorage.getItem("edit_brand") ||
        localStorage.getItem("brand_id");


    const [rows, setRows] = useState(
        [...allRows].sort((a, b) => Number(b.status) - Number(a.status))
    );

    // Initialize selectedRows based on status
    const [selectedRows, setSelectedRows] = useState(
        allRows.filter(row => row.status).map(row => row.id)
    );
    const [dragIndex, setDragIndex] = useState(null);

    // ---------------------------
    // Checkbox selection
    // ---------------------------
    const handleCheckbox = (id) => {
        let updated = rows.map(row =>
            row.id === id
                ? { ...row, status: !row.status }
                : row
        );

        // Sort so true → top, false → bottom
        updated = updated.sort((a, b) => Number(b.status) - Number(a.status));

        setRows(updated);

        const newSelected = updated
            .filter(row => row.status)
            .map(row => row.id);

        setSelectedRows(newSelected);
    };




    // ---------------------------
    // Drag start
    // ---------------------------
    const handleDragStart = (index) => {
        setDragIndex(index);
    };

    // ---------------------------
    // Drag over → reorder rows
    // ---------------------------
    const handleDragOver = (e, index) => {
        e.preventDefault();
        if (dragIndex === index) return;

        const updated = [...rows];
        const draggedItem = updated[dragIndex];

        updated.splice(dragIndex, 1);
        updated.splice(index, 0, draggedItem);

        setDragIndex(index);
        setRows(updated);
    };

    // ---------------------------
    // Handle input field change
    // ---------------------------
    const handleChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };

    const handleCancel = () => {
        history.goBack();
    };

    const handleSubmit = () => {
        const headersObject = rows.reduce((acc, item) => {
            acc[item.header_key] = {
                label: item.header_label,
                color: item.color.replace("#", ""),
                name: item.name,
                abbreviation: item.abbreviation,
                status: item.status,
            };
            return acc;
        }, {});

        const payload = {
            brand: brand_id,
            headers: headersObject,
        };

        updateBrandReconHeaders(payload, USER_TOKEN)
            .then(() => {
                alert("Headers updated successfully!");
                history.push("/app/recon-report-brand", { refresh: true });
            })
            .catch(() => {
                alert("Failed to update headers.");
            });
    };

    return (
        <div className="notoSansFont">
            <h2 className="mb-4 mt-2">Edit Headers</h2>

            <table className="dt-table">
                <thead>
                    <tr>
                        <th style={{ width: "70px" }}>Select</th>
                        <th>Header Name</th>
                        <th>Header Label</th>
                        <th>Color</th>
                        <th>Description</th>
                    </tr>
                </thead>

                <tbody>
                    {rows.map((row, index) => (
                        <tr
                            key={row.id}
                            draggable
                            className="draggable-row"
                            onDragStart={() => handleDragStart(index)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            style={{ cursor: "grab" }}
                        >
                            <td style={{ textAlign: "center" }}>
                                <input
                                    type="checkbox"
                                    checked={row.status}
                                    onChange={() => handleCheckbox(row.id)}
                                />

                            </td>
                            <td>
                                <input
                                    type="text"
                                    value={row.name}
                                    disabled
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    value={row.header_label}
                                    onChange={(e) =>
                                        handleChange(index, "header_label", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="color"
                                    value={row.color}
                                    onChange={(e) =>
                                        handleChange(index, "color", e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <p>{row.abbreviation || ""}</p>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="mt-4 d-flex gap-3">
                <CustomBlueButton title="Cancel" onClick={handleCancel} />
                <CustomBlueButton title="Submit" onClick={handleSubmit} />
            </div>
        </div>
    );
};

export default ReconReportBrandEdit;
